Object.defineProperty(exports, "__esModule", {value: true});

var js_Boot = require('./js/Boot');

exports.default = function $estr() {
	return js_Boot.__string_rec(this, '');
}
